export default __webpack_public_path__ + "static/media/approve_button.7fae4e6d.svg";